"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isArray = isArray;
// https://github.com/microsoft/TypeScript/issues/17002
function isArray(arg) {
    return Array.isArray(arg);
}
//# sourceMappingURL=isArray.js.map